const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const usefulLinksReducer = (state = {}, action) => {
  switch (action.type) {
    case 'RESET_USEFUL_LINKS_OBJ':
      return {}
    case 'RESET_USEFUL_LINKS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'USEFUL_LINKS_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_USEFUL_LINKS':
      return {
        ...state,
        status: {
          get_useful_links: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    case 'SET_USEFUL_LINKS':
      return {
        ...state,
        skills: { ...state.skills, ...action.payload },
        status: {
          get_useful_links: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'UPDATE_USEFUL_LINKS':
      return {
        ...state,
        status: {
          update_useful_links: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'UPDATED_USEFUL_LINKS':
      return {
        ...state,
        status: {
          update_useful_links: {
            ...initialStatus,
            success: true,
            message: action?.payload?.message,
          },
        },
      }

    default:
      return state
  }
}

export default usefulLinksReducer
